export default "__VITE_ASSET__3221c495__"